<div class="min-h-screen bg-gradient-to-br from-amber-50 to-amber-100 p-2 sm:p-6">
  <div class="max-w-7xl mx-auto">
    <!-- Header Section -->
    <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
      <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">
      
        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>
      
          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ payload?.proposal_name }}]
          </h5>
      
      
        </div>
        <div>
          
          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all" [ngClass]="{
                          'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                        }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                            'bg-slate-500': stepDetails?.step_status == 0,
                            'bg-emerald-500': stepDetails?.step_status == 'approved',
                            'bg-amber-500': stepDetails?.step_status == 'recommended',
                            'bg-blue-500': stepDetails?.step_status == 'initiated'
                          }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

        <!-- Action Buttons -->
        <div class="flex flex-wrap items-center gap-2">
          <button (click)="generatePDF()" 
                  class="inline-flex items-center px-4 py-2.5 bg-white border-2 border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 hover:border-slate-400 transition-all duration-200 font-medium text-sm shadow-sm hover:shadow">
            <i class="pi pi-file-pdf mr-2"></i> PDF
          </button>

         

          <ng-container *ngIf="stepDetails?.can_edit">
            <button (click)="routeConfig.emit({isRouteConfig: true})"  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
              <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
            </button>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent mb-6"></div>

    <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md"
    *ngIf="schemeType == 'idex' && challengesData">
 <div (click)="toggleSection('challengeForm')"
     class="flex items-center justify-between p-4 cursor-pointer bg-gray-200 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
   <h3 class="text-lg font-semibold flex items-center">
     <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
       <i class="pi pi-file-edit"></i>
     </span> Challenge Form   <span class="w-12 p-1 border-2 border-purple-500 ml-5 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm"> View </span>
     </h3>
   <i class="pi transition-transform duration-200"   [ngClass]="expandedSections['challengeForm'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
 </div>
 <div *ngIf="expandedSections['challengeForm']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
    <app-idex-from [stepDetails]="challengesData" [challengesData]="challengesData" ></app-idex-from>
 </div>
</div>


    <form [formGroup]="commentForm" >
  
      <div>
        <div class="bg-amber-50 border-2 border-gray-300 mb-3 rounded transition-all duration-200 hover:shadow-md"
             *ngIf="schemeType != 'makeI' && schemeType != 'makeII' && schemeType != 'makeIII'">
          <div (click)="toggleSection('basicInfo')"
              class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
            <h3 class="text-lg font-semibold flex items-center">
              <span class="w-8 h-8 rounded-lg bg-yellow-100 text-yellow-600 flex items-center justify-center mr-3 text-sm">
                <i class="pi pi-calendar"></i>
              </span>
            Challenge Start & End Date
            </h3>
            <i class="pi transition-transform duration-200"
               [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </div>
          <div *ngIf="expandedSections['basicInfo']" class="py-2 px-4 border-t border-slate-100 animate-fade-in">
            <div class="flex flex-col md:flex-row md:items-center md:space-x-6 space-y-4 md:space-y-0">
              <!-- Challenge Status -->
              <div class="flex-1 flex flex-col">
                <label for="challenge_status" class="block font-medium text-slate-700 mb-2">
                  Challenge Status <span class="text-red-500">*</span>
                </label>
                <div class="w-full">

                  <p-dropdown 
                    id="challenge_status"
                    formControlName="challenge_status"
                    [options]="[
                      {label: 'Duplicate', value: 'Duplicate'},
                      {label: 'Reject', value: 'Reject'},
                      {label: 'Launch', value: 'Launch'}
                    ]"
                    optionValue="value"
                    optionLabel="label"
                    styleClass="w-full"
                    placeholder="Select Challenge Status"
                  ></p-dropdown>
                </div>
              </div>
              <!-- Start Date -->
              <div class="flex-1 flex flex-col">
                <label for="start_date" class="block font-medium text-slate-700 mb-2">
                  Start Date <span class="text-red-500">*</span>
                </label>
                <input pInputText id="start_date" type="date" [readonly]="commentForm.get('challenge_status')?.value == 'Duplicate' || commentForm.get('challenge_status')?.value == 'Reject'"
                       class="w-full px-4 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                       formControlName="start_date"
                       autocomplete="off" />
              </div>
              <!-- End Date -->
              <div class="flex-1 flex flex-col">
                <label for="end_date" class="block font-medium text-slate-700 mb-2">
                  End Date <span class="text-red-500">*</span>
                </label>
                <input pInputText id="end_date" type="date" [readonly]="commentForm.get('challenge_status')?.value == 'Duplicate' || commentForm.get('challenge_status')?.value == 'Reject'"
                       class="w-full px-4 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                       formControlName="end_date"
                       autocomplete="off" />
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="stepDetails?.code === 'makeI_02'; else otherSteps">
          <app-upload-document [isEditable]="stepDetails?.can_edit" [proposal_step]="stepDetails?.id - 1"></app-upload-document>
        </ng-container>
        <ng-template #otherSteps>
          <app-upload-document [isEditable]="stepDetails?.can_edit"></app-upload-document>
        </ng-template>
  
        <!-- Section: Document Uploads (styled as IDEx form) -->
        <!-- <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
          <div (click)="toggleSection('uploads')"
               class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
            <h3 class="text-lg font-semibold flex items-center">
              <span class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
                <i class="pi pi-paperclip"></i>
              </span>
             Reference Document
            </h3>
            <i class="pi transition-transform duration-200"
               [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </div>
          <div *ngIf="expandedSections['uploads']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
            
          </div>
        </div> -->
      </div>
     
    </form>

  </div>
</div>

<style>
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fade-in 0.3s ease-out;
}
</style>